import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import './assets/high-contrast.css'

/* eslint-disable no-unused-vars */
import { VuetifyTiptap, VuetifyViewer, createVuetifyProTipTap, defaultBubbleList } from 'vuetify-pro-tiptap'

const app = createApp(App)


app.use(router)
app.use(store)
app.use(vuetify)
app.use(i18n)
app.use(createVuetifyProTipTap({
  lang: i18n.global.locale.value,
  i18n: i18n.global.t
}))

app.mount('#app')